import Button, * as Btn from '@lib/components/Button';
import ListItem from '@lib/components/ListItem';
import RecipientEdit from '@lib/components/RecipientEdit';
import TitleBar, * as ITitleBar from '@lib/components/TitleBar';
import { RecipientListProps } from '@lib/containers/RecipientList';
import { isEmailValid, isPhoneNumberValid } from '@lib/util/util';
import * as React from 'react';
import { INativeNavigator, IRecipient } from 'types';
import './RecipientList.css';


declare var Waves: any;

interface IRecipientListState {
  isEmailError: boolean,
  isPhoneNumberError: boolean,
  recipients: IRecipient[];
  recipient: IRecipient;
  showEdit: boolean;
  showTrash: boolean;
  modified: boolean;
}

class RecipientList extends React.Component<RecipientListProps, IRecipientListState> {

  public constructor(props: RecipientListProps) {
    super(props);
    let recipients: IRecipient[] = [];
    if (this.props.site && this.props.site.recipients) {
      recipients = this.props.site.recipients;
    }
    this.state = {
      isEmailError: false, isPhoneNumberError: false, modified: false,
      recipient: { id: -1, phoneNumber: '', email: '', technicalAlarm: false, inputAlarm: false, modified: false },
      recipients, showEdit: false, showTrash: false,
    };
  }

  public componentDidMount() {
    Waves.attach('div.listItem', 'waves-light');
  }

  /**
   * Fired when user clicks on an item 
   * @param state 
   * @param event 
   */
  public onItemClick(id: number, event: React.MouseEvent<HTMLDivElement>) {
    if (this.state.showTrash) {
      // It's a deletion
      const recipients = [];
      for (const recipient of this.state.recipients) {
        if (recipient.id !== id) {
          recipients.push(recipient);
        }
      }
      this.setState({ recipients, modified: true });
    } else {
      if (id === -1) {
        // Add new, find first empty
        let maxId: number = -1;
        let recipient: IRecipient;
        for (const rec of this.state.recipients) {
          if (maxId < rec.id) {
            maxId = rec.id;
          }
          if (rec.email === '' && rec.phoneNumber === '') {
            recipient = rec;
            this.setState({ recipient, showEdit: true });
            break;
          }
        }
        // No empty
        recipient = { email: '', id: maxId + 1, phoneNumber: '', inputAlarm: false, technicalAlarm: false, modified: false };
        this.state.recipients.push(recipient);
        this.setState({ recipient, showEdit: true, isEmailError: false, isPhoneNumberError: false });
      } else {
        // Edit existing
        let recipient: IRecipient;
        for (const rec of this.state.recipients) {
          if (rec.id === id) {
            recipient = rec;
            this.setState({ recipient, showEdit: true, isEmailError: false, isPhoneNumberError: false });
            break;
          }
        }
      }
    }

  }


  /**
   * Fired when user click on menu hamburger button
   * @param event 
   */
  public onMenuClick(event: React.MouseEvent<HTMLDivElement>) {
    if (!this.state.modified || confirm(this.props.i18n.Common.confirmCancel)) {
      this.props.onGoBack();
    }
  }

  /**
   * Fired when user wants to validate all modification
   */
  public onValidateClick() {
    // Check that there is maximum 10 for technical and 10 for input
    let nbInputAlarm: number = 0;
    let nbTechnicalAlarm: number = 0;
    for (const rec of this.state.recipients) {
      if (rec.technicalAlarm) { nbTechnicalAlarm++ };
      if (rec.inputAlarm) { nbInputAlarm++ };
    }
    if (nbTechnicalAlarm > 10) {
      /* tslint:disable:no-empty */
      (navigator as INativeNavigator).notification.alert(this.props.i18n.RecipientList.maxTenTechnicalAlarm, () => { }, 'Smart TX');
      return;
    }
    if (nbInputAlarm > 10) {
      /* tslint:disable:no-empty */
      (navigator as INativeNavigator).notification.alert(this.props.i18n.RecipientList.maxTenInputAlarm, () => { }, 'Smart TX');
      return;
    }
    this.props.onSave(this.props.site!.device!.id, this.props.site!.name, this.state.recipients);
  }


  /**
   * Fired when user click on Trash bottom button
   * @param event 
   */
  public onTrashClick(event: React.MouseEvent<HTMLDivElement>) {
    this.setState({ showTrash: !this.state.showTrash });
  }

  /**
   * Fired when user click on check in recipient edit
   * @param event 
   */
  public onSaveRecipientEdit(event: React.MouseEvent<HTMLDivElement>) {
    const mailValid: boolean = (this.state.recipient.email === '' || isEmailValid(this.state.recipient.email));
    const numberValid: boolean = (this.state.recipient.phoneNumber === '' || isPhoneNumberValid(this.state.recipient.phoneNumber));
    if (mailValid && numberValid) {
      if (!this.state.recipient.inputAlarm && !this.state.recipient.technicalAlarm) {
        if (!confirm(this.props.i18n.RecipientList.confirmNotChecked)) {
          return;
        }
      }
      // Store data
      const recipients: IRecipient[] = this.state.recipients;
      for (const rec of this.state.recipients) {
        if (rec.id === this.state.recipient.id) {
          rec.email = this.state.recipient.email;
          rec.phoneNumber = this.state.recipient.phoneNumber;
          rec.inputAlarm = this.state.recipient.inputAlarm;
          rec.technicalAlarm = this.state.recipient.technicalAlarm;
        }
      }
      this.props.onGoResetMessages();
      this.setState({ recipients, showEdit: false });
    } else {
      this.setState({ isEmailError: !mailValid, isPhoneNumberError: !numberValid });
    }
  }



  /**
   * Fired when user click on check in recipient edit
   * @param event 
   */
  public onTestRecipientEdit(event: React.MouseEvent<HTMLDivElement>) {
    if (this.props.working) { return; }
    const mailValid: boolean = (this.state.recipient.email === '' || isEmailValid(this.state.recipient.email));
    const numberValid: boolean = (this.state.recipient.phoneNumber === '' || isPhoneNumberValid(this.state.recipient.phoneNumber));
    if (mailValid && numberValid) {
      this.props.onTest(this.props.site!.device!.id, this.state.recipient);
    } else {
      this.setState({ isEmailError: !mailValid, isPhoneNumberError: !numberValid });
    }
  }

  /**
   * Fired when user change login input field
   * @param state 
   * @param event 
   */
  public onChangeEmail(state: IRecipientListState, event: React.ChangeEvent<HTMLInputElement>) {
    const recipient = this.state.recipient;
    recipient.email = event.currentTarget.value.toLowerCase();
    recipient.modified = true;
    this.setState({ recipient, modified: true, isEmailError: this.state.isEmailError && !isEmailValid(event.currentTarget.value) });
  }

  /**
   * Fired when user change password input field
   * @param state 
   * @param event 
   */
  public onChangePhone(state: IRecipientListState, event: React.ChangeEvent<HTMLInputElement>) {
    const recipient = this.state.recipient;
    recipient.phoneNumber = event.currentTarget.value.toLowerCase();
    recipient.modified = true;
    this.setState({ recipient, modified: true, isPhoneNumberError: this.state.isPhoneNumberError && !isPhoneNumberValid(event.currentTarget.value) });
  }

  /**
   * Fired when user clicks on "Alarm" checkbox
   * @param state 
   * @param event 
   */
  public onAlarmClick(state: IRecipientListState, event: React.MouseEvent<HTMLDivElement>) {
    const recipient = this.state.recipient;
    recipient.inputAlarm = !recipient.inputAlarm;
    recipient.modified = true;
    this.setState({ recipient });
  }


  /**
   * Fired when user clicks on "Notif" checkbox
   * @param state 
   * @param event 
   */
  public onNotifClick(state: IRecipientListState, event: React.MouseEvent<HTMLDivElement>) {
    const recipient = this.state.recipient;
    recipient.technicalAlarm = !recipient.technicalAlarm;
    recipient.modified = true;
    this.setState({ recipient });
  }





  public render() {

    if (this.props.site === undefined || this.props.site.recipients === undefined) {
      window.location.pathname = '/';
      window.location.hash = '';
      return null;
    }

    const i18n = this.props.i18n.RecipientList;

    return (
      <div className="standardPage recipientList">
        {this.state.showEdit &&
          <RecipientEdit
            errorMessage={this.props.errorMessage}
            i18n={this.props.i18n}
            isEmailError={this.state.isEmailError}
            isPhoneNumberError={this.state.isPhoneNumberError}
            onAlarmClick={this.onAlarmClick.bind(this, this.state)}
            onNotifClick={this.onNotifClick.bind(this, this.state)}
            onChangeEmail={this.onChangeEmail.bind(this, this.state)}
            onChangeNumber={this.onChangePhone.bind(this, this.state)}
            onValidateClick={this.onSaveRecipientEdit.bind(this, this.state)}
            onTestClick={this.onTestRecipientEdit.bind(this, this.state)}
            recipient={this.state.recipient}
            successMessage={this.props.successMessage}
            title={i18n.titleEdit}
            working={this.props.working}
          />
        }
        <div className="recipientList" style={{
          alignItems: 'center', display: "flex", flexDirection: "column",
        }}>
          <TitleBar
            leftIcon={ITitleBar.ICO_CHEVRON_LEFT}
            onLeftButtonClick={this.onMenuClick.bind(this, this.state)}
            title={i18n.title}
            rightIcon={this.props.saving ? ITitleBar.ICO_CHECK_ROTATING : ITitleBar.ICO_CHECK}
            onRightButtonClick={this.onValidateClick.bind(this, this.state)}
          />
          <div id="recipientList">
            {this.state.recipients.map((recipient: IRecipient) => {
              if (recipient.email !== '' || recipient.phoneNumber !== '') {
                return (
                  <ListItem icoClass={this.state.showTrash ? 'trash' : ''} fontClass={recipient.modified ? 'modified' : ''} title={recipient.email!} detail={recipient.phoneNumber} key={recipient.id} onClick={this.onItemClick.bind(this, recipient.id, recipient.email)} />
                )
              }
              return null;
            })}
          </div>
          <Button labelFA='trash' type={Btn.BTN_TYPE_CIRCLE_UP} onClick={this.onTrashClick.bind(this, 'trash')} />
          <Button labelFA='plus' type={Btn.BTN_TYPE_CIRCLE} onClick={this.onItemClick.bind(this, -1)} />
        </div>
      </div>
    );
  }
}

export default RecipientList;



// WEBPACK FOOTER //
// ./src/pages/RecipientList.tsx